import type { EntityTemplateEntity } from "@/entities/entity-template";

import { useEffect, useState } from "react";

import { useUpdateEntityTemplate } from "@/entities/entity-template";
import { useApiErrorHandler } from "@/modules/api-errors";
import { useSaveBar } from "@/modules/app-save-bar";

export const useTemplateSchema = (
  template: EntityTemplateEntity | undefined
) => {
  const initSchema = template?.content;
  const [schema, setSchema] = useState(initSchema);
  const { setIsDirty } = useSaveBar();
  const { onError } = useApiErrorHandler();
  const { mutate, isPending: isLoading } = useUpdateEntityTemplate(
    template?.id || 0
  );

  useEffect(() => {
    setSchema(initSchema);
  }, [initSchema]);

  const onUpdate = (modifiedSchema: object, isRegistrable: boolean) => {
    setSchema(modifiedSchema);
    if (isRegistrable) setIsDirty(true);
  };

  const onCancel = () => {
    setSchema(initSchema);
    setIsDirty(false);
  };

  const onSave = () => {
    const data = {
      content: schema,
    };
    mutate(data, {
      onSuccess: function () {
        setIsDirty(false);
      },
      onError,
    });
  };

  return { schema, onSave, onUpdate, onCancel, isSaving: isLoading };
};
